module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-select"
  }, [(_vm.hasLabel) ? _c('label', {
    staticClass: "p-input-label",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "p-select-wrapper",
    class: {
      'multiple': _vm.multiple
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    staticClass: "p-select",
    attrs: {
      "id": _vm.id,
      "disabled": _vm.disabled,
      "multiple": _vm.multiple
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.innerModel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onChange]
    }
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ab3feb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/select.vue
// module id = 30
// module chunks = 0